import { Moment } from "moment";
import { AccommodationType } from "./accommodation-type";
import { AppointmentType } from "./appointment-type";
import { BoardType } from "./board-type";
import { ContactRequestSource } from "./contact-request-source";
import { Country } from "./country";
import { InterestLevel } from "./interest-level";
import { Language } from "./language";
import { LeadStatus } from "./lead-status";
import { LeadType } from "./lead-type";
import { RoomType } from "./room-type";
import { SalesAgent } from "./sales-agent";
import { School } from "./school";
import { SystemUser } from "./system-user";
import { UserForBackend } from "./user-for-backend";

export class ContactRequest {
    constructor(
        public firstName: string,
        public lastName: string,
        public email: string,
        public phoneNumber: string,
        public city: string,
        public country: Country,
        public postCode: string,
        public interestedIn: string,
        public message: string,
        public isoCode: string,
        public formType: string | null,
        public language: Language,
        public isDeleted: boolean,
        public interestLevel: InterestLevel,
        public source: ContactRequestSource,
        public leadType: LeadType,
        public startDate: Moment | null,
        public endDate: Moment | null,
        public destination: Country,
        public school: School,
        public birthDate: Moment | null,
        public constantContactId: string | null,
        public cityCountry: string | null,
        public courseType: string | null,
        public courseOption: string | null,
        public accommodationType: AccommodationType | null,
        public roomType: RoomType | null,
        public boardType: BoardType | null,
        public promoCode: string | null,
        public needInsurance: boolean,
        public needGarantieAnnulation: boolean,
        public otherAccommodationType: string | null,
        public otherRoomType: string | null,
        public otherBoardType: string | null,
        public appointmentType: AppointmentType | null,
        public versionId: number | null,
        public secondEmail: string | null, 
        public salesAgent?: SalesAgent,
        public id?: number | null,
        public created?: Date | null,
        public isProcessed?: boolean,
        public dateToContact?: Moment | null,
        public usersInCharge?: UserForBackend[],
        public duration?: number | null,
        public leadStatus?: LeadStatus,
        public ageAtStartDate?: number | null
    ){
        if(startDate && endDate){
            this.duration = Math.round(endDate.diff(startDate, "weeks", true));
        }       
    }
}
